module.exports = __webpack_public_path__ + "img/badge-list-thumb-028.45556eff.png";